<script lang="ts" setup>
import { SrcSet } from '~/composables/useSrcSet'

export interface WidgetEmployeesItemProps {
    employee: Employee
    headingLevel: string
}

const props = defineProps<WidgetEmployeesItemProps>()

const imageSrc = computed((): SrcSet | undefined => {
    if (props.employee.avatar) {
        return useSrcSet(props.employee.avatar.path)
    }
})
</script>

<template>
  <article
    class="d-md-flex align-items-center p-3 pb-8 pb-md-3 rounded box-shadow-1"
  >
    <img
      v-if="props.employee.avatar?.path"
      :src="imageSrc?.src"
      :srcset="imageSrc?.srcSet"
      :width="100"
      :height="100"
      loading="lazy"
      decoding="async"
      class="d-block rounded-circle flex-shrink-0 mx-auto ms-md-0 mb-3 mb-md-0 me-md-6"
      alt=""
    >
    <div class="text-md-start">
      <Heading
        :level="props.headingLevel"
        class="zeta mb-1"
      >
        {{ props.employee.name }}
      </Heading>
      <p>{{ props.employee.position }}</p>
    </div>
  </article>
</template>
